/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_StripInputs */



/**
* | output |
* | --- |
* | "Chat with Wundo" |
*
* @param {Chat_StripInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_strip = /** @type {((inputs?: Chat_StripInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_StripInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Chat met Wundo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Discuter avec Wundo")
	return /** @type {LocalizedString} */ ("Chat with Wundo")
});